export default __webpack_public_path__ + "img/24.58ba091.svg";